import enMessages from '../locale/en-US';

const EnLang = {
  messages: {
    ...enMessages,
  },
  locale: 'en-US',
};
export default EnLang;
